import * as React from 'react';
import styles from './index.less';
import FResourceStatusBadge from '../FResourceStatusBadge';
import FCoverImage from '@/components/FCoverImage';
import FCoverFooterButtons from '@/components/FCoverFooterButtons';
import FTooltip from '@/components/FTooltip';
import FComponentsLib from '@freelog/components-lib';
import { FI18n, FUtil } from '@freelog/tools-lib';
import img_choiceLabel from '@/assets/choice-label@2x.png';
import { MouseEventHandler } from 'react/index';
import FIcons from '@/components/FIcons';

type EventFunc = () => void;

export interface FResourceCardProps {
  className?: string;
  type?: 'resource' | 'favorite' | 'market';
  showUserInfo?: boolean;
  resource: {
    id: string;
    cover: string;
    name: string;
    title: string;
    version: string;
    policy: string[];
    type: string[];
    status: 0 | 1 | 2 | 4;
    authProblem?: boolean;
    updateDate: string;
    username: string;
    useAvatar: string;
    isChoice: boolean;
    /** RSS 相关资源：卡片「更新」禁用 */
    isRssRelated?: boolean;
    collection?: {
      status: 'finish' | 'unFinish';
      count: number;
    } | null;
  };
  onBoomJuice?: EventFunc;
  onClickDetails?: EventFunc;
  onClickEditing?: EventFunc;
  onClickRevision?: EventFunc;
  // onClickMore?: EventFunc;
  onClick?: MouseEventHandler<HTMLDivElement>;
}

function FResourceCard({
  className = '',
  type = 'market',
  resource,
  onBoomJuice,
  onClickDetails,
  onClickEditing,
  onClickRevision,
  onClick,
  showUserInfo = true,
}: // collection,
FResourceCardProps) {
  const isMarket = type === 'market';

  return (
    <div
      onClick={(event) => {
        onClick && onClick(event);
      }}
      className={[
        styles.styles,
        className,
        isMarket ? styles.gesture : '',
        isMarket ? styles.marketCard : '',
      ].join(' ')}
    >
      <div className={styles.Cover}>
        <FCoverImage
          src={resource.cover}
          width={isMarket ? '100%' : 280}
          // Figma：封面 scaleMode FIT，完整显示且至少一边贴满
          fit={isMarket ? 'contain' : undefined}
          className={isMarket ? styles.coverImage : undefined}
          style={
            isMarket
              ? {
                  borderRadius: 0,
                  // 覆盖 FCoverImage 默认 4:3，由外层 .Cover 定高
                  aspectRatio: 'unset',
                }
              : { borderRadius: 4 }
          }
        />
        {type !== 'market' && (
          <>
            {!!resource.collection && (
              <label className={styles.collectionLabel}>
                <div>{FI18n.i18nNext.tAuto('resource_card_collection_subject')}</div>
                <div
                  style={{
                    border: '1px solid #FFFFFF',
                    opacity: 0.2,
                    height: 10,
                  }}
                />
                <div>
                  {resource.collection.status === 'finish'
                    ? '已完结'
                    : // : '连载中'
                      FI18n.i18nNext.tAuto('cqr_itemmgmt_updatestates_ongoing')}
                </div>
                <div
                  style={{
                    border: '1px solid #FFFFFF',
                    opacity: 0.2,
                    height: 10,
                  }}
                />
                <div>
                  {FI18n.i18nNext.tAuto('resource_card_collection_itemcount', {
                    itemCount: resource.collection.count,
                  })}
                </div>
              </label>
            )}

            <nav className={styles.CoverMask}>
              {type === 'favorite' ? (
                <FCoverFooterButtons
                  buttons={[
                    {
                      type: 'resourceDetails',
                      fn() {
                        onClickDetails && onClickDetails();
                      },
                    },
                    {
                      type: 'cancelCollect',
                      fn() {
                        onBoomJuice && onBoomJuice();
                      },
                    },
                  ]}
                />
              ) : (
                <FCoverFooterButtons
                  buttons={[
                    {
                      type: 'resourceDetails',
                      fn() {
                        onClickDetails && onClickDetails();
                      },
                    },
                    {
                      type: 'edit',
                      fn() {
                        onClickEditing && onClickEditing();
                      },
                    },
                    {
                      type: 'update',
                      disabled: !!resource.isRssRelated,
                      fn() {
                        onClickRevision && onClickRevision();
                      },
                    },
                  ]}
                />
              )}
            </nav>
            <div className={styles.Status}>
              <FResourceStatusBadge
                status={
                  resource.status === 2
                    ? 'freeze'
                    : resource.status === 1
                    ? 'online'
                    : resource.status === 0
                    ? 'unreleased'
                    : 'offline'
                }
              />

              {resource.authProblem && (
                <FTooltip
                  // title={'存在授权问题'}
                  title={FI18n.i18nNext.tAuto('alert_resource_no_auth')}
                >
                  <FIcons.FWarning style={{ fontSize: 16 }} />
                </FTooltip>
              )}

              {resource.isChoice && (
                <FTooltip title={'编辑精选'} placement={'bottomLeft'}>
                  <img src={img_choiceLabel} alt={''} style={{ width: 24, height: 24 }} />
                </FTooltip>
              )}
            </div>
          </>
        )}

        {type === 'market' && resource.isChoice && (
          <>
            <FTooltip title={'编辑精选'} placement={'bottomLeft'}>
              <img
                src={img_choiceLabel}
                alt={''}
                style={{
                  width: 24,
                  height: 24,
                  position: 'absolute',
                  top: 10,
                  left: 10,
                }}
              />
            </FTooltip>
          </>
        )}

        {type === 'market' && !!resource.collection && (
          <label className={styles.collectionLabel} style={{ bottom: 10 }}>
            <div>{FI18n.i18nNext.tAuto('resource_card_collection_subject')}</div>
            <div
              style={{
                border: '1px solid #FFFFFF',
                opacity: 0.2,
                height: 10,
              }}
            />
            <div>
              {resource.collection.status === 'finish'
                ? // '已完结'
                  FI18n.i18nNext.tAuto('cqr_itemmgmt_updatedstates_completed')
                : // : '连载中'
                  FI18n.i18nNext.tAuto('cqr_itemmgmt_updatestates_ongoing')}
            </div>
            <div
              style={{
                border: '1px solid #FFFFFF',
                opacity: 0.2,
                height: 10,
              }}
            />
            <div>
              {FI18n.i18nNext.tAuto('resource_card_collection_itemcount', {
                itemCount: resource.collection.count || 0,
              })}
            </div>
          </label>
        )}
      </div>
      {isMarket ? (
        <>
          <div className={styles.body}>
            <FComponentsLib.FContentText
              singleRow={true}
              text={resource.title || resource.name.split('/')[1]}
              type={'highlight'}
              style={{ maxWidth: '100%' }}
            />
            <FComponentsLib.FContentText
              type="additional2"
              text={FUtil.Format.resourceTypeKeyArrToResourceType(resource.type)}
              style={{ maxWidth: '100%' }}
              singleRow
            />
            <FComponentsLib.FContentText
              singleRow
              style={{ maxWidth: '100%' }}
              type="additional2"
              text={FI18n.i18nNext.tAuto('resource_card_label_lastupdated', {
                LatestUpdatedTime: resource.updateDate,
              })}
            />
          </div>
          <div className={styles.policy}>
            {resource.policy.length > 0 ? (
              <FComponentsLib.F_Contract_And_Policy_Labels
                data={resource.policy.map((p) => {
                  return {
                    text: p,
                    dot: '',
                  };
                })}
                singleRow
              />
            ) : (
              <FComponentsLib.FContentText
                text={FI18n.i18nNext.tAuto('resource_card_msg_noplans')}
                type="additional2"
              />
            )}
          </div>
          {showUserInfo && (
            <div className={styles.user}>
              <div
                className={styles.avatar}
                style={{
                  backgroundImage: `url(${resource.useAvatar || img_choiceLabel})`,
                }}
              />
              <span>{resource.username}</span>
            </div>
          )}
        </>
      ) : (
        <>
          <div style={{ height: 10 }} />
          <FComponentsLib.FContentText
            singleRow={true}
            text={resource.title || resource.name.split('/')[1]}
            type={'highlight'}
            style={{ maxWidth: 280 }}
          />
          <div style={{ height: 5 }} />
          <FComponentsLib.FContentText
            type="additional2"
            text={FUtil.Format.resourceTypeKeyArrToResourceType(resource.type)}
            style={{ maxWidth: 280 }}
            singleRow
          />
          <div style={{ height: 5 }} />
          <FComponentsLib.FContentText
            singleRow
            style={{ maxWidth: 280 }}
            type="additional2"
            text={FI18n.i18nNext.tAuto('resource_card_label_lastupdated', {
              LatestUpdatedTime: resource.updateDate,
            })}
          />
          <div style={{ height: 5 }} />
          <div className={styles.policy}>
            {resource.policy.length > 0 ? (
              <FComponentsLib.F_Contract_And_Policy_Labels
                data={resource.policy.map((p) => {
                  return {
                    text: p,
                    dot: '',
                  };
                })}
                singleRow
              />
            ) : (
              <FComponentsLib.FContentText
                text={FI18n.i18nNext.tAuto('resource_card_msg_noplans')}
                type="additional2"
              />
            )}
          </div>
          {showUserInfo && (
            <>
              <div style={{ height: 12 }} />
              <div className={styles.user}>
                <div
                  className={styles.avatar}
                  style={{
                    backgroundImage: `url(${resource.useAvatar || img_choiceLabel})`,
                  }}
                />
                <span>{resource.username}</span>
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
}

export default FResourceCard;
